import { gql } from "@apollo/client";

export const RESET_USER_CORRECT_QUESTIONS = gql`
  mutation ResetUserCorrectQuestions($tag: String!) {
    resetUserCorrectQuestions(tag: $tag)
  }
`;